<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog" :size="mobileVersion ? 'fs' : 'lg-fix-h'">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{ $t('verifactu.correction_header') }}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 overflow-x-auto"
        :style="mobileVersion ? 'height: 80vh;' : 'height: 60vh;'">
        <el-form ref="ruleForm" class="h-full flex flex-col" :model="form" :rules="rules">
          <el-form-item v-for="[key, field] in errorData" :key="key" :prop="key">
            <label class="text-sm font-semibold text-secondary-600 dark:text-darkblue-400 black:text-darkblue-500 block mb-1"><base-obligatory-icon v-if="field.required" />{{ key }}</label>
            <base-el-select v-if="field.type.toUpperCase() === 'ENUM'" v-model="form[key].value" :options="field.data" filterable clearable :option-value="opt => opt.Codigo" :option-label="opt => opt.Descripcion" />
            <el-date-picker v-else-if="field.type.toUpperCase() === 'DATE'" class="!w-full" v-model="form[key].value" type="date" :picker-options="dateRangeOptions"
              popper-class="!z-[2020]" :format="datePattern" value-format="yyyy-MM-dd[T00:00:00]" />
            <el-input v-else v-model="form[key].value" />
          </el-form-item>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <div class="flex flex-row w-full justify-between">
        <base-button class="w-full mx-2" @click="toggleDialog" mode="secondary-phantom-blue" :text="$t('app.cancel')" />
        <base-button mode="secondary-phantom-blue" class="w-full mx-2" :text="$t('app.subsanar')" @click="subsanar('ruleForm')" />
      </div>
    </template>
  </base-dialog-button>
</template>
<script>
import { clone } from 'lodash'
import { i18n } from '@/i18n'
import getLocaleDateTimeFormat from '@/services/functions/getLocaleDateTimeFormat'
import { subsanarVerifactu } from '@/services/verifactu/subsanarVerifactu'

export default {
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
    mobileVersion: {
      type: Boolean,
      default: false
    },
    idCliente: {
      type: Number,
      required: true
    },
    csvzc: {
      type: String,
      required: true
    },
    errorVerifactu: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      form: {},
      dateRangeOptions: {
        firstDayOfWeek: 1
      },
    }
  },
  computed: {
    errorData: function () {
      return Object.entries(this.errorVerifactu?.SubsanacionObject ?? {})
    },
    defaultForm: function () {
      return this.errorData.reduce((acc, [key, data]) => ({ ...acc, [key]: this.preserve(['value'], data) }), {})
    },
    rules: function () {
      return this.errorData.filter(entry => entry[1].required).reduce((acc, [key, data]) => ({
        ...acc,
        [key]: [
          {
            required: data.required,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change'],
          }
        ] 
      }), {})
    },
    datePattern () {
      const formatKey = 'numeric_date'
      const locale = i18n.locale || 'es'
      return getLocaleDateTimeFormat(formatKey, locale)
    },
    role: function () {
      return this.$store.getters['auth/role']
    }
  },
  watch: {
    dialogOpen: function (value, oldValue) {
      if (value && value !== oldValue) {
        this.resetForm()
      }
    }
  },
  created: function () {
    this.resetForm()
  },
  mounted: function () {
    
  },
  methods: {
    getDefaultForm: function () {
      return clone(this.defaultForm)
    },
    resetForm: function () {
      this.form = this.getDefaultForm()
    },
    toggleDialog: function (event) {
      this.$emit('toggleDialog', event)
    },
    subsanar: function (ruleForm) {
      this.$refs[ruleForm].validate(async valid => {
        if (valid) {
          const params = {
            idCl: null
          }
          if ([3, 7, 8].includes(this.role)) {
            params.idCl = this.idCliente
          }
          const payload = {
            CSVZC: this.csvzc,
            codigoError: this.errorVerifactu.CodigoError,
            Data: this.form
          }
          const response = await subsanarVerifactu(params, payload)
          if (response.blnError) {
            this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
          } else {
            this.toggleDialog()
            this.$emit('applyDialog', { CSVZC: response.Respuesta })
            this.resetForm()
          }
        } else {
          this.doFeedback(i18n.t('feedback.error.process_data_error'))
        }
      })
    }
  },
}
</script>
<style scoped>

</style>
